import { ColorsMap, RootLevelDimensionsList } from '../../../../types';
import { YieldReportStatsLabel } from '../RegionReportItemsRow/YieldReportStatsLabel';
import { ColorStatsLabel } from '../RegionReportItemsRow/ColorStatsLabel';
import { SetItemCallback } from '../container/useRegionReportController';

export type ArdRegionReportItemsProps = {
  allowHover?: boolean;
  colors: ColorsMap;
  data?: RootLevelDimensionsList;
  dataTestId: string;
  locale: string;
  onClickItem?: SetItemCallback;
  showIcon?: boolean;
  index: number;
  displayRanges: boolean;
  cropCode: string;
};

export const ArdRegionReportItems = ({
  colors,
  data = [],
  dataTestId,
  index,
  onClickItem,
  cropCode
}: ArdRegionReportItemsProps) => (
    <>
      {data.map((item) => {
        if (Object.keys(colors).length > 0) {
          return <ColorStatsLabel
            colors={colors}
            dataTestId={dataTestId}
            index={index}
            item={item}
            onClickItem={onClickItem}
            cropCode={cropCode}
            key={`ard-color-stats-${dataTestId}-${item.stats.stdYield?.v ?? 'unknown'}`}
          />
        }

        return (
          <YieldReportStatsLabel
            dataTestId={dataTestId}
            index={index}
            item={item}
            onClickItem={onClickItem}
            cropCode={cropCode}
            key={`ard-yield-stats-${dataTestId}-${item.stats.stdYield?.v ?? 'unknown'}`}
            isArdData
          />
        );
      })}
    </>
  );